import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import QRCode, { QRCodeToDataURLOptions } from 'qrcode';
import { AccountManagementEvent } from '@/services/analytics/events';

const DEFAULT_OPTIONS: QRCodeToDataURLOptions = {
  errorCorrectionLevel: 'H',
  width: 145,
  type: 'image/png',
  margin: 0,
  scale:3
};

@Component({
  name: 'CmgQrCode',
})
export default class CmgQrCode extends Vue {
  @Prop({ required: true, type: String })
  value!: string;

  @Prop({ type: String })
  text?: string;

  @Prop({ default: () => DEFAULT_OPTIONS, type: Object })
  options!: QRCodeToDataURLOptions;

  mounted() {
    this.draw();
    this.$services.analytics.send(new AccountManagementEvent('qrScanned'));
  }

  draw() {
    const root = this.$refs['root'] as HTMLCanvasElement;
    if (!root) {
      return;
    }

    QRCode.toDataURL(root, this.value, this.options, err => {
      if (!err) {
        return;
      }

      this.$services.logger.error('Something went wrong rendering QR code', undefined, err);
    });
  }

  updated() {
    this.draw();
  }
}
